export const homePath = '/'
export const supporterPath = '/supporter/:action'
export const peerSupporterLeadPath = '/peersupporterlead/:action'
export const adminPath = '/admin'

export const supporterPathStub = '/supporter'
export const peerSupporterLeadPathStub = '/peersupporterlead'
export const adminPathStub = '/admin'
